import React from 'react';
import { Package, Brush, Gem, Book, Briefcase } from 'lucide-react';

const SubscriptionBadge = ({ tier }) => {
  const tierConfig = {
    free: {
      label: 'Free',
      icon: Book,
      bgColor: 'var(--muted)',
      textColor: 'var(--text-secondary)',
      borderColor: 'var(--sketch-border)'
    },
    starter: {
      label: 'Starter',
      icon: Package,
      bgColor: 'var(--accent-1)',
      textColor: 'white',
      borderColor: 'var(--accent-1)'
    },
    premium: {
      label: 'Premium',
      icon: Brush,
      bgColor: 'var(--accent-2)',
      textColor: 'white',
      borderColor: 'var(--accent-2)'
    },
    family: {
      label: 'Family',
      icon: Gem,
      bgColor: 'var(--accent-5)',
      textColor: 'white',
      borderColor: 'var(--accent-5)'
    },
    folio: {
      label: 'Folio Access Pass',
      icon: Briefcase,
      bgColor: '#4f46e5',
      textColor: 'white',
      borderColor: '#4f46e5'
    }
  };

  const config = tierConfig[tier] || tierConfig.free;
  const Icon = config.icon;

  return (
    <div 
      className="inline-flex items-center gap-2 px-3 py-1 rounded-full border-2 font-sketch text-sm"
      style={{
        background: config.bgColor,
        color: config.textColor,
        borderColor: config.borderColor
      }}
    >
      <Icon className="w-4 h-4" />
      <span className="font-semibold">{config.label}</span>
    </div>
  );
};

export default SubscriptionBadge;
